var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixRestaurantsCatalogsV3Discount from '@wix/ambassador-restaurants-catalogs-v3-discount/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var DiscountType;
(function (DiscountType) {
    DiscountType["UNSPECIFIED_TYPE"] = "UNSPECIFIED_TYPE";
    DiscountType["OFF_ITEM"] = "OFF_ITEM";
    DiscountType["OFF_ORDER"] = "OFF_ORDER";
})(DiscountType || (DiscountType = {}));
export var FulfillmentType;
(function (FulfillmentType) {
    FulfillmentType["UNSPECIFIED_FULFILLMENT_TYPE"] = "UNSPECIFIED_FULFILLMENT_TYPE";
    FulfillmentType["DELIVERY"] = "DELIVERY";
    FulfillmentType["PICKUP_OR_DINE_IN"] = "PICKUP_OR_DINE_IN";
})(FulfillmentType || (FulfillmentType = {}));
export var DiscountPlatform;
(function (DiscountPlatform) {
    DiscountPlatform["UNSPECIFIED_PLATFORM"] = "UNSPECIFIED_PLATFORM";
    DiscountPlatform["SITE"] = "SITE";
    DiscountPlatform["MOBILE_SITE"] = "MOBILE_SITE";
    DiscountPlatform["CALL_CENTER"] = "CALL_CENTER";
})(DiscountPlatform || (DiscountPlatform = {}));
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["UNDEFINED"] = "UNDEFINED";
    DayOfWeek["SUN"] = "SUN";
    DayOfWeek["MON"] = "MON";
    DayOfWeek["TUE"] = "TUE";
    DayOfWeek["WED"] = "WED";
    DayOfWeek["THU"] = "THU";
    DayOfWeek["FRI"] = "FRI";
    DayOfWeek["SAT"] = "SAT";
})(DayOfWeek || (DayOfWeek = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _createDiscountRequest = {};
const _createDiscountResponse = {};
const _getDiscountRequest = {};
const _getDiscountResponse = {};
const _listDiscountsRequest = {};
const _listDiscountsResponse = {};
const _updateDiscountRequest = {};
const _updateDiscountResponse = {};
/**
 * Retrieves a discount.
 * @public
 * @documentationMaturity preview
 * @requiredField identifiers
 * @requiredField identifiers.catalogId
 * @requiredField identifiers.discountId
 * @returns Retrieved discount.
 */
export function getDiscount(identifiers) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            catalogId: '$[0].catalogId',
            discountId: '$[0].discountId',
        };
        const responseTransformation = '$.discount';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getDiscountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getDiscountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers]);
        const reqOpts = ambassadorWixRestaurantsCatalogsV3Discount.getDiscount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a discount.
 * A discount can belong to a catalog, section, or dish. You can't create a discount that applies to a menu.
 * @public
 * @documentationMaturity preview
 * @requiredField identifiers
 * @requiredField identifiers.catalogId
 * @requiredField identifiers.discountId
 * @adminMethod
 * @returns Updated discount.
 */
export function updateDiscount(identifiers, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            catalogId: '$[0].catalogId',
            discount: { '*': '$[1].discount', id: '$[0].discountId' },
        };
        const responseTransformation = '$.discount';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateDiscountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateDiscountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([identifiers, options]);
        const reqOpts = ambassadorWixRestaurantsCatalogsV3Discount.updateDiscount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'identifiers',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a discount.
 * You can create discounts for catalogs, sections, or dishes. You can't create a discount that applies to a menu.
 * @param catalogId - ID of the catalog the discount belongs to.
 * @public
 * @documentationMaturity preview
 * @requiredField catalogId
 * @requiredField options
 * @requiredField options.discount
 * @requiredField options.discount.active
 * @requiredField options.discount.condition.fulfillmentTypes
 * @requiredField options.discount.condition.minOrderPrice
 * @requiredField options.discount.condition.platforms
 * @requiredField options.discount.name
 * @adminMethod
 * @returns Created discount.
 */
export function createDiscount(catalogId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            catalogId: '$[0]',
            discount: '$[1].discount',
        };
        const responseTransformation = '$.discount';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createDiscountRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createDiscountResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['discount']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([catalogId, options]);
        const reqOpts = ambassadorWixRestaurantsCatalogsV3Discount.createDiscount(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'catalogId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves up to 1000 discounts.
 * @param catalogId - ID of the catalog the discounts belong to.
 * @public
 * @documentationMaturity preview
 * @requiredField catalogId
 */
export function listDiscounts(catalogId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            catalogId: '$[0]',
            fieldMask: '$[1].fieldMask',
            active: '$[1].active',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listDiscountsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listDiscountsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#discounts']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([catalogId, options]);
        const reqOpts = ambassadorWixRestaurantsCatalogsV3Discount.listDiscounts(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'catalogId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=restaurants-catalogs-v3-discount.universal.js.map